import * as otherAttachmentActions from './actions';

import { DetailsOtherAttachmentsActionTypes, DetailsOtherAttachmentsState, OtherAttachmentsUIState } from './types';

import { ActionType } from 'typesafe-actions';
import { Reducer } from 'redux';
import { getEnv } from '../../utils/env/env.manager';

export type OtherAttachmentAction = ActionType<typeof otherAttachmentActions>;

const env = getEnv();
const baseURL = env.baseURL;


const initialState: DetailsOtherAttachmentsState = {
  otherAttachments: [],
  requestState: OtherAttachmentsUIState.NotSetYet,
  urlForDownload: `${baseURL}/documents/download/`,
  urlForPreview: `${baseURL}/documents/preview/`
};

const reducer: Reducer<DetailsOtherAttachmentsState, OtherAttachmentAction> = (state = initialState, action): DetailsOtherAttachmentsState => {
  switch (action.type) {
    case DetailsOtherAttachmentsActionTypes.FETCH_OTHER_ATTACHMENTS: {
      return { ...state, requestState: OtherAttachmentsUIState.Downloading };
    }
    case DetailsOtherAttachmentsActionTypes.FETCH_OTHER_ATTACHMENTS_SUCCESS: {
      return { ...state, otherAttachments: [...action.payload], requestState: OtherAttachmentsUIState.Downloaded };
    }
    case DetailsOtherAttachmentsActionTypes.UPLOAD_OTHER_ATTACHMENTS: {
      return { ...state, requestState: OtherAttachmentsUIState.Uploading };
    }
    case DetailsOtherAttachmentsActionTypes.UPLOAD_OTHER_ATTACHMENTS_SUCCESS: {
      const otherAttachments = state.otherAttachments.map((attachment, index) =>
        index === action.payload.index
          ? { ...attachment, id: action.payload.documentId, isOnline: true, AVScanned: false, VirusDetected: false }
          : attachment
      );

      return { ...state, otherAttachments };
    }
    case DetailsOtherAttachmentsActionTypes.DELETE_OTHER_ATTACHMENTS: {
      return { ...state, requestState: OtherAttachmentsUIState.Deleting };
    }
    case DetailsOtherAttachmentsActionTypes.DELETE_OTHER_ATTACHMENTS_SUCCESS: {
      const otherAttachments = [...state.otherAttachments];
      otherAttachments.splice(action.payload.index, 1);

      return { ...state, requestState: OtherAttachmentsUIState.Deleted, otherAttachments: otherAttachments };
    }
    case DetailsOtherAttachmentsActionTypes.ADD_OTHER_ATTACHMENTS: {
      return { ...state, otherAttachments: [...state.otherAttachments, ...action.payload.attachments] };
    }
    case DetailsOtherAttachmentsActionTypes.UPDATE_DESCRIPTION: {
      const otherAttachments = state.otherAttachments.map((attachment, index) =>
        index === action.payload.index
          ? { ...attachment, description: action.payload.description }
          : attachment
      );

      return { ...state, otherAttachments };
    }
    case DetailsOtherAttachmentsActionTypes.SET_OTHER_ATTACHMENTS_REQUEST_STATE: {
      return { ...state, requestState: action.payload.requestState };
    }
    case DetailsOtherAttachmentsActionTypes.DELETE_OTHER_ATTACHMENTS_FAIL: {
      return { ...state, requestState: OtherAttachmentsUIState.DeleteFail };
    }
    case DetailsOtherAttachmentsActionTypes.UPLOAD_OTHER_ATTACHMENTS_FAIL: {
      return { ...state, requestState: OtherAttachmentsUIState.UploadFail };
    }
    case DetailsOtherAttachmentsActionTypes.FETCH_OTHER_ATTACHMENTS_FAIL: {
      return { ...state, requestState: OtherAttachmentsUIState.DownloadFail };
    }
    default:
      return state;
  }
};

export { initialState as detailsOtherAttachmentsInitialState, reducer as detailsOtherAttachmentsReducer };
